import { z } from "zod";

const EnvSchema = z.object({
	baseApiUrl: z.string().url(),
	appUrl: z.string().url(),
	appVersion: z.string(),
	isProd: z.boolean(),
	authKeyToken: z.string(),
	authKeyClient: z.string(),
	authKeyUid: z.string(),
	authKeyId: z.string(),
	webviewKey: z.string(),
	isSecureHttp: z.boolean(),
	pubnubPubKey: z.string(),
	pubnubSubKey: z.string(),
	pubnubUuid: z.string(),
	oneSignalAppId: z.string(),
	oneSignalSafariId: z.string(),
	turnstileSiteKey: z.string(),
});

function validateEnv() {
	try {
		const env = import.meta.env;
		const config: z.infer<typeof EnvSchema> = {
			baseApiUrl: env.VITE_API_BASE_URL,
			appUrl: env.VITE_APP_URL,
			appVersion: env.VITE_APP_VERSION || "1.0.0",
			pubnubPubKey: env.VITE_APP_PUBNUB_PUB_KEY,
			pubnubSubKey: env.VITE_APP_PUBNUB_SUB_KEY,
			pubnubUuid: env.VITE_APP_PUBNUB_UUID,
			oneSignalAppId: env.VITE_APP_ONESIGNAL_APP_ID,
			oneSignalSafariId: env.VITE_APP_ONESIGNAL_SAFARI_ID,
			turnstileSiteKey: env.VITE_TURNSTILE_SITE_KEY,
			authKeyToken: "medplaner-token",
			authKeyClient: "medplaner-client",
			authKeyUid: "medplaner-uid",
			authKeyId: "medplaner-id",
			webviewKey: "medplaner-webview",
			get isSecureHttp() {
				return this.appUrl.startsWith("https");
			},
			get isProd() {
				return this.appUrl === "https://app.hemiteams.ai";
			},
		};
		const parsedEnv = EnvSchema.parse(config);
		return parsedEnv;
	} catch (err) {
		throw new Error(`Invalid environment variables: ${(err as any).message}`);
	}
}

const env = validateEnv();

export default env;
